

export default function ServicesSection() {
  const services = [
    {
      title: 'PNFストレッチ',
      duration: '60分・30分',
      image: 'https://static.readdy.ai/image/b5bfa44d5950b8773965295c375e5018/10604a92b078202a9a64b1e5c8cf0362.png',
      description: '全身の疲労を緩和し、一人では伸ばしきれないところまで全身ストレッチ。30分コースでは肩甲骨はがし、股関節、肩回りなど気になる箇所を集中的に。',
      features: ['全身疲労緩和', '柔軟性向上', '血行促進', '姿勢改善']
    },
    {
      title: 'PNFボディメイクフェイシャルストレッチ',
      duration: '30分',
      image: 'https://static.readdy.ai/image/b5bfa44d5950b8773965295c375e5018/974ea40b707e217f6ff5e038823978b3.jpeg',
      description: '小顔・リフトアップ効果！肩こりや眼精疲労の方にお勧めです。',
      features: ['小顔効果', 'リフトアップ', '眼精疲労改善', '肩こり解消']
    },
    {
      title: 'パーソナルトレーニング',
      duration: '30分・60分',
      image: 'https://static.readdy.ai/image/b5bfa44d5950b8773965295c375e5018/4eb17c5881941ebfef275d510d037705.jpeg',
      description: 'トレーナーがマンツーマンで正しいフォームを指導。一人ひとりに合ったメニューをご提案します。',
      features: ['マンツーマン指導', '正しいフォーム', '個別メニュー', '効果的トレーニング']
    },
    {
      title: 'パーソナルトレーニング＋ストレッチ',
      duration: '60分',
      image: 'https://static.readdy.ai/image/b5bfa44d5950b8773965295c375e5018/3438f5424d3f3571ca04f0fcfe84a558.jpeg',
      description: '30分間正しいフォームで追い込んだ後、残りの30分でストレッチを行いカラダをスッキリ整えます。',
      features: ['トレーニング30分', 'ストレッチ30分', '総合ケア', 'カラダ調整']
    },
    {
      title: 'ボディもみほぐし',
      duration: '15分・30分',
      image: 'https://static.readdy.ai/image/b5bfa44d5950b8773965295c375e5018/0c432b92ee1274cc7aa22402722f6842.png',
      description: '時間の無い方や、ストレッチと組み合わせてご利用もおすすめです。',
      features: ['短時間対応', '疲労回復', 'リラクゼーション', '組み合わせ可能']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">サービス内容</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            お客様のお悩みや目標に合わせて、最適なメニューをご提案いたします
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="relative h-48">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover object-center"
                />
                <div className="absolute top-4 right-4 bg-teal-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                  {service.duration}
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
                
                <div className="space-y-2">
                  {service.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="flex items-center text-sm text-gray-707">
                      <div className="w-4 h-4 flex items-center justify-center mr-2">
                        <i className="ri-check-line text-teal-600"></i>
                      </div>
                      {feature}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

